export default __webpack_public_path__ + "static/media/html5back.c4c0f4d4.svg";